export class UpgradeSapAgentInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetVersion",
            "baseName": "targetVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "artifactUrl",
            "baseName": "artifactUrl",
            "type": "string",
            "format": "uri"
        },
        {
            "name": "artifactSha256",
            "baseName": "artifactSha256",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpgradeSapAgentInput.attributeTypeMap;
    }
    constructor() {
    }
}
